import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { appActions, useGetFeatureFlagsConfigQuery, useGetGlobalSettingsQuery } from 'app/appState';
import { isAuthKeyEmpty, useGetMeQuery, userActions, getCredentials } from 'entities/User';
import { useSocketConnect } from 'app/socketConnection';
import { useSpecialPromotionModal } from 'features/SpecialPromotion';
import { useInitTrackingParams } from 'features/TrackingParams';
import { getPromotionContentByClient } from 'shared/utils/helpers/getPromotionContentByClient';

export const useInitializeApp = (): void => {
  const dispatch = useAppDispatch();

  const userHasToken = !isAuthKeyEmpty();

  const { data: userData, refetch: refetchMe } = useGetMeQuery(undefined, { skip: !userHasToken });
  const { data: globalSettings } = useGetGlobalSettingsQuery();
  const { data: featureFlags } = useGetFeatureFlagsConfigQuery();

  const credentials = useAppSelector(getCredentials);

  useSocketConnect();

  useInitTrackingParams();

  const { initSpecialPromotionModal } = useSpecialPromotionModal();

  const PromotionContent = getPromotionContentByClient(globalSettings?.clientName);

  // refetch user data when tokens have been updated
  useEffect(() => {
    void (credentials && refetchMe());
  }, [credentials, refetchMe]);

  useEffect(() => {
    userData && dispatch(userActions.setUserData(userData));
    globalSettings && dispatch(appActions.setGlobalSettings(globalSettings));
    featureFlags && dispatch(appActions.setFeatureFlags(featureFlags));
  }, [userData, dispatch, globalSettings, featureFlags]);

  useEffect(() => {
    initSpecialPromotionModal(PromotionContent);
  }, [PromotionContent, initSpecialPromotionModal]);
};
